<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'reports.download_report' | translate }}
    v-card-content
      v-select(
        :label="$t('reports.company_blank')"
        :options="additionals"
        v-model="selectedBlank")
    v-card-actions
      v-btn(
        :loading="loading"
        :disabled="!isSelectedBlank"
        @click="getReport") {{ 'base.create' | translate }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FileSaver from 'file-saver'

export default {
  name: 'CreateBlankModal',

  props: {
    link: {
      type: String,
      required: true
    },

    report: {
      type: String,
      required: true
    }
  },

  data: () => ({
    selectedBlank: null,
    loading: false
  }),

  mounted () {
    this.loadBlanksList()
  },

  computed: {
    ...mapGetters('additional', [
      'additionals'
    ]),

    ...mapGetters('reports', [
      'filters'
    ]),

    isSelectedBlank () {
      return !!this.selectedBlank
    }
  },

  methods: {
    ...mapActions('additional', [
      'loadAdditionals'
    ]),

    ...mapActions('reports', [
      'makeReport'
    ]),

    ...mapActions('reports', [
      'applyFilters'
    ]),

    async loadBlanksList () {
      const filters = {
        farm: this.$route.params.farm_id
      }
      await this.loadAdditionals(filters)
    },

    async getReport () {
      this.filters.report = this.report
      this.filters.additional = this.selectedBlank
      this.loading = true
      this.downloadReport(await this.makeReport(this.link, this.filters))
      this.loading = false
      this.$emit('close')
    },

    b64toFile (b64Data, filename, contentType) {
      const sliceSize = 512
      const byteCharacters = atob(b64Data)
      const byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)
        const byteNumbers = new Array(slice.length)

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      const file = new File(byteArrays, filename, {type: contentType})
      return file
    },

    async downloadReport ({ report, name }) {
      const file = this.b64toFile(report, name, 'application/vnd.ms-excel;charset=utf-8')
      FileSaver.saveAs(file, name)
    }
  }
}
</script>

